import { render, staticRenderFns } from "./SocialAuthBtn.vue?vue&type=template&id=6b3d67b7&scoped=true"
import script from "./SocialAuthBtn.vue?vue&type=script&lang=js"
export * from "./SocialAuthBtn.vue?vue&type=script&lang=js"
import style0 from "./SocialAuthBtn.vue?vue&type=style&index=0&id=6b3d67b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3d67b7",
  null
  
)

export default component.exports